import { render, staticRenderFns } from "./r-tabs.vue?vue&type=template&id=bc65ad4e&"
import script from "./r-tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./r-tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./r-tabs.vue?vue&type=style&index=0&id=bc65ad4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports